// API
import { api } from './api';

// Types
import { FetchPendingActiviesResponseType } from '../../types/Fetch';

export default async function fetchPendingActivites(
    leadId: string,
    token: string
): Promise<FetchPendingActiviesResponseType> {
    let _url = api.workflowCancelpendingActivities.replace(/:leadId/, leadId);

    const resp = await fetch(_url, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    return {
        data: resp.status === 200 ? resp.json() : Promise.resolve([]),
        status: resp.status,
        error: resp.status === 200 ? undefined : resp,
    };
}
